import api from '@pray/shared/utils/api';

export async function getAllPushCampaigns({
  artistId = '',
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
} = {}) {
  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/artists/${artistId}/campaigns/push`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
